import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const TokenHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const processToken = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setError('No authentication token provided.');
        setProcessing(false);
        return;
      }

      try {
        // Store token in localStorage
        localStorage.setItem('token', token);
        
        // Set auth header
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Verify token with backend
        const response = await axios.get('/api/auth/me');
        
        if (response.data && response.data.user) {
          // Token is valid - redirect to dashboard
          window.location.href = '/dashboard';
        } else {
          throw new Error('Invalid token response');
        }
      } catch (err) {
        console.error('Token authentication failed:', err);
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        setError('Authentication failed. Please try signing in again.');
        setProcessing(false);
      }
    };

    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    } else {
      processToken();
    }
  }, [searchParams, navigate, isAuthenticated]);

  if (processing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Authenticating...</p>
          <p className="text-gray-400 text-sm mt-2">Please wait while we sign you in.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md">
          <div className="text-red-500 text-5xl mb-4">⚠</div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Authentication Error</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <a href="/login" className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors">
            Go to Sign In
          </a>
        </div>
      </div>
    );
  }

  return null;
};

export default TokenHandler;
